import type { ComponentNode } from '../../../store/checkoutBuilder/types';
import CheckoutText from '../checkout-components/CheckoutText';

type Props = {
  node: ComponentNode;
  selected: boolean;
  onSelect: () => void;
  onUpdateProps: (patch: Record<string, any>) => void;
  dragHandleProps?: any;
  onDelete?: () => void;
  onDuplicate?: () => void;
};

export default function TextAdapter({ node, selected, onSelect, onUpdateProps, dragHandleProps, onDelete, onDuplicate }: Props) {
  const cfg = node.props || {};
  return (
    <CheckoutText
      selected={selected}
      config={{
        text: cfg.text ?? 'Título',
        fontColor: cfg.fontColor ?? '#222',
        fontSize: cfg.fontSize ?? 'huge',
        textAlign: cfg.textAlign ?? 'left',
        background: cfg.background,
        borderColor: cfg.borderColor,
        borderWidth: cfg.borderWidth,
        radius: cfg.radius,
      }}
      onSelect={onSelect}
      onConfigChange={(patch) => onUpdateProps(patch as Record<string, any>)}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      dragHandleProps={dragHandleProps}
    />
  );
}
